import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import constant from '@constants/constant'
import endpoint from '@constants/apipath'
import common from '@state/modules/common'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  fetchCustomer({ state }, { pageNumber, pageSize } = {}) {
    return axios
      .get(
        // `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcustomers}?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=1&key=CustomerType&value=customer`,
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcustomersbyuserid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  fetchCustomerProducts({ state }, customerId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.adminApiPath.getcustomerproduct
    }`
    return axios
      .post(url, customerId, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchVolumeReport({ commit }, { volumeReportjsonData } = {}) {
    let url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.volumereportget}` +
      '?FromDate=' +
      volumeReportjsonData.startdate +
      '&ToDate=' +
      volumeReportjsonData.enddate +
      '&TimeZone=Eastern Standard Time' +
      volumeReportjsonData.customerId +
      volumeReportjsonData.selectedProducts +
      '&isBranch=' +
      volumeReportjsonData.isBranch
    return axios
      .get(url, {
        responseType: 'arraybuffer',
        headers: setHeaders(),
      })
      .then((response) => {
        let fromDate = common.getDatepart(volumeReportjsonData.startdate)
        let toDate = common.getDatepart(volumeReportjsonData.enddate)
        let reportName = `${constant.volumeReport}_${
          volumeReportjsonData.customerAccNumber
        }_${fromDate}_${toDate}.pdf`

        if (window.navigator && window.navigator.msSaveBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'application/pdf' })
          window.navigator.msSaveBlob(blob1, reportName)
        } else {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = reportName
          link.click()
        }
      })
      .catch((error) => {
        return error
      })
  },

  downloadVolumeReports({ commit }, { volumeReportjsonData } = {}) {
    let url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.downloadvolumereport}` +
      '?FromDate=' +
      volumeReportjsonData.startdate +
      '&ToDate=' +
      volumeReportjsonData.enddate +
      '&TimeZone=Eastern Standard Time' +
      volumeReportjsonData.customerId +
      volumeReportjsonData.selectedProducts +
      '&isBranch=' +
      volumeReportjsonData.isBranch

    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        let fromDate = common.getDatepart(volumeReportjsonData.startdate)
        let toDate = common.getDatepart(volumeReportjsonData.enddate)
        let reportName = `${constant.volumeReport}_${
          volumeReportjsonData.customerAccNumber
        }_${fromDate}_${toDate}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, reportName)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', reportName)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
